import { safeParseNullDefault, safeParse } from 'shouldve-been-js';

class User {

    private _userId: string;
    private _username: string;
    private _firstName: string;
    private _lastName: string;
    private _signature: string;
    private _roleId: string | null;
    private _rank: string;

    public constructor(userId: string, username: string, firstName: string, lastName: string, signature: string, roleId: string | null, rank: string) {

        this._userId = userId;
        this._username = username;
        this._firstName = firstName;
        this._lastName = lastName;
        this._signature = signature;
        this._roleId = roleId;
        this._rank = rank;
    }

    public get userId(): string {
        return this._userId;
    }

    public set userId(value: string) {
        this._userId = value;
    }

    public get username(): string {
        return this._username;
    }

    public set username(value: string) {
        this._username = value;
    }

    public get firstName(): string {
        return this._firstName;
    }

    public set firstName(value: string) {
        this._firstName = value;
    }

    public get lastName(): string {
        return this._lastName;
    }

    public set lastName(value: string) {
        this._lastName = value;
    }

    public get signature(): string {
        return this._signature;
    }

    public set signature(value: string) {
        this._signature = value;
    }

    public get roleId(): string | null {
        return this._roleId;
    }

    public set roleId(value: string | null) {
        this._roleId = value;
    }

    public get rank(): string {
        return this._rank;
    }

    public set rank(value: string) {
        this._rank = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): User | null {

        const userId: string | null = safeParseNullDefault<string>(json?.userId, '');
        const username: string | null = safeParseNullDefault<string>(json?.userName, '');
        const firstName: string = safeParse<string>(json?.firstName, '');
        const lastName: string = safeParse<string>(json?.lastName, '');
        const signature: string = safeParse<string>(json?.signature, '');
        const roleId: string | null = safeParseNullDefault<string>(json?.roleId, '');
        const rank: string = safeParse<string>(json?.rank, '');

        if (userId === null || username === null || userId === '' || username === '') {
            return null;
        }

        return new User(userId, username, firstName, lastName, signature, roleId, rank);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): User | null {

        const userId: string | null = safeParseNullDefault<string>(object?._userId, '');
        const username: string | null = safeParseNullDefault<string>(object?._username, '');
        const firstName: string = safeParse<string>(object?._firstName, '');
        const lastName: string = safeParse<string>(object?._lastName, '');
        const signature: string = safeParse<string>(object?._signature, '');
        const roleId: string | null = safeParseNullDefault<string>(object?._roleId, '');
        const rank: string = safeParse<string>(object?._rank, '');

        if (userId === null || username === null || userId === '' || username === '') {
            return null;
        }

        return new User(userId, username, firstName, lastName, signature, roleId, rank);
    }

    public getNameString(): string {

        return this.firstName + ' ' + this.lastName;
    }
}

export default User;